// Import global styles
require("./src/css/style.css");
require("./src/css/reset.css");
